import React from "react";
import Session from "supertokens-web-js/recipe/session";
import { useLocation } from "react-router-dom";
import { REDIRECT_URL } from "../contant";
import { toast } from "react-toastify";
import LoaderComponent from "../component/LoaderComponent";

export default function LogoutPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const redirectUrl = queryParams.get(REDIRECT_URL);

  async function logout() {
    await Session.signOut();
    localStorage.clear();
    window.location.href = redirectUrl;
    document.cookie =
      "g_state=; expires=Thu, 01 Jan 2000 00:00:00 UTC; path=/;";
  }

  React.useEffect(() => {
    const checkSession = async () => {
      try {
        if (await Session.doesSessionExist()) {
          logout();
          return true;
        } else {
          toast.error("User has not logged in yet");
          window.location.href = redirectUrl;
          return false;
        }
      } catch (error) {
        toast.error("Session is not valid");
        return false;
      }
    };
    checkSession();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoaderComponent label={"Logging you out..."} />;
}
